@if((deskmode() !=='xs' && deskmode() !=='sm')) {
<header class="header">
    <ng-container *ngTemplateOutlet="navcontent"></ng-container>
</header>
} @else {
<ng-container *ngTemplateOutlet="mobileMode"></ng-container>
}

<ng-template #mobileMode>
    <div class="headermob">
        <!-- <ng-container *ngTemplateOutlet="mobilelogo"></ng-container> -->
        <div class="logowrapper">
            <button class="logo-a" (click)="gotohome()">
                <img src="../../../../assets/images/corallogo.svg" alt="">
            </button>
        </div>
        <div style="display: flex;align-items: center;">
            <a class="afon" href="tel:{{partner?.tel}}" (mouseover)="fixsetoultip=true"
                (mouseleave)="fixsetoultip=false" #trigertooltip="cdkOverlayOrigin" cdkOverlayOrigin>
                <mat-icon style="color:#F46600;">call</mat-icon>
            </a>

            @if(partner?.multilangualktiv) {
            <button [matMenuTriggerFor]="langmenu" aria-label="menu" class="cc8" matRipple>
                @switch (i18nService.langUp) {
                @case ('de') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/de.svg" class="langimg" alt="flag de"> <span>Deutsch</span>
                </div>
                }
                @case ('DE') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/de.svg" class="langimg" alt="flag de"> <span>Deutsch</span>
                </div>
                }
                <!-- @case ('TR') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/tr.svg" class="langimg" alt="flag tr"> <span>Türkçe</span>
                </div>
                }
                @case ('tr') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/tr.svg" class="langimg" alt="flag tr"> <span>Türkçe</span>
                </div>
                } -->
                @case ('NL') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/nl.svg" class="langimg" alt="flag nl"> <span>Nederlands</span>
                </div>
                }
                @case ('nl') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/nl.svg" class="langimg" alt="flag nl"> <span>Nederlands</span>
                </div>
                }
                <!-- @case ('FR') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/fr.svg" class="langimg" alt="flag fr"> <span>Français</span>
                </div>
                }
                @case ('fr') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/fr.svg" class="langimg" alt="flag fr"> <span>Français</span>
                </div>
                } -->
                @case ('RU') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/ru.svg" class="langimg" alt="flag ru"> <span>Русский</span>
                </div>
                }
                @case ('ru') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/ru.svg" class="langimg" alt="flag ru"> <span>Русский</span>
                </div>
                }
                @case ('en-GB') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/gb.svg" class="langimg" alt="flag gb"> <span>English</span>
                </div>
                }
                @case ('EN-GB') {
                <div class="langwrp">
                    <img src="../../../../../assets/flags/gb.svg" class="langimg" alt="flag gb"> <span>English</span>
                </div>
                }
                }
            </button>
            <mat-menu #langmenu="matMenu">
                <button mat-menu-item (click)="changeLng('de')" aria-label="de" matRipple>
                    <div class="langwrp">
                        <img src="../../../../../assets/flags/de.svg" class="langimg" alt="flag de">
                        <span>Deutsch</span>
                    </div>
                </button>
                <!-- <button mat-menu-item (click)="changeLng('tr')" aria-label="tr" matRipple>
                    <div class="langwrp">
                        <img src="../../../../../assets/flags/tr.svg" class="langimg" alt="flag tr"> <span>Türkçe</span>
                    </div>
                </button>
                <button mat-menu-item (click)="changeLng('fr')" aria-label="fr" matRipple>
                    <div class="langwrp">
                        <img src="../../../../../assets/flags/fr.svg" class="langimg" alt="flag fr">
                        <span>Français</span>
                    </div>
                </button> -->
                <button mat-menu-item (click)="changeLng('nl')" aria-label="nl" matRipple>
                    <div class="langwrp">
                        <img src="../../../../../assets/flags/nl.svg" class="langimg" alt="flag nl">
                        <span>Nederlands</span>
                    </div>
                </button>
                <button mat-menu-item (click)="changeLng('en-GB')" aria-label="en-GB" matRipple>
                    <div class="langwrp">
                        <img src="../../../../../assets/flags/gb.svg" class="langimg" alt="flag gb">
                        <span>English</span>
                    </div>
                </button>
                <button mat-menu-item (click)="changeLng('ru')" aria-label="ru" matRipple>
                    <div class="langwrp">
                        <img src="../../../../../assets/flags/ru.svg" class="langimg" alt="flag ru">
                        <span>Русский</span>
                    </div>
                </button>
            </mat-menu>
            }

        </div>
    </div>
</ng-template>

<ng-template #mobilelogo>
    <div>
        <button class="logo-a-mobile" (click)="gotohome()">
            @if(logo()?.length > 0) {
            <img class="lazyload logo-img-mobile" data-src="{{logo()}}" alt="{{partner?.firmenname}} logo">
            }
        </button>
    </div>
</ng-template>

<ng-template #navcontent>
    <div class="subheaderwrapper">
        <div class="logowrapper">
            <button class="logo-a" (click)="gotohome()">
                <img src="../../../../assets/images/corallogo.svg" alt="">
            </button>
        </div>

        @if(partner && !partner?.hideSearch && !isBooking) {
        <clever-headersearch></clever-headersearch>
        }
        <div class="headerwrapper mr5">
            <ng-container *ngTemplateOutlet="subnavcontent"></ng-container>
        </div>
    </div>
    @if(!isBooking){
    <div class="tmp_right-wrapper">
        <div class="tmp_mnwrp">
            <div class="dflx ml5">
                <clever-menu2 [deskmode]="deskmode()" [mobile]="mobile" [showChat]="!partner?.hideChat"
                    [showTermin]="!partner?.hideTermin" [showhReisekompass]="!partner?.hideReisekompass"
                    [showhLogin]="!partner?.hideLogin" [showhDigbrater]="!partner?.hideDigbrater"></clever-menu2>
            </div>
        </div>
    </div>
    }
</ng-template>

<ng-template #subnavcontent>
    <div class="submenuwrapper">
        @if(!isBooking){
        <div class="dflx mr5">
            <ng-container *ngIf="currentCustomer?.asPartner">
                <app-chatampel></app-chatampel>
            </ng-container>
            @if(partner && !partner?.hideDigbrater) {
            <button (click)="gotoAnfrage()" class="subheaderbtn" aria-label="Digitaler Reiseberater"
                matTooltip="Digitaler Reiseberater" matRipple>
                <mat-icon fontIcon="smart_toy"></mat-icon>
            </button>
            }
            <button (click)="gotofavorites()" [matBadge]="favoritesCount > 0 ? favoritesCount : ''"
                matBadgeOverlap="false" matTooltip="Favoriten" aria-label="favorite" matBadgeSize="small"
                matBadgePosition="above after" matBadgeColor="warn" class="subheaderbtn" matRipple>
                <mat-icon fontIcon="favorite"></mat-icon>
                <span multilang style="padding:0 0.5rem">Favoriten</span>
            </button>
            @if(partner && !partner?.hideReisekompass) {
            <button (click)="gotoContent()" class="subheaderbtn" aria-label="Reisekompass" matTooltip="Reisekompass"
                matRipple>
                <mat-icon fontIcon="explore"></mat-icon>
                <span multilang style="padding:0 0.5rem">Reisekompass</span>
            </button>
            }

            @if(currentCustomer?.asPartner) {
            <button (click)="gotoOfferpack()" [matBadge]="offerpackCount > 0 ? offerpackCount : ''"
                matBadgeOverlap="false" matTooltip="Angebotsliste" matBadgeSize="small" matBadgePosition="above after"
                matBadgeColor="warn" class="subheaderbtn" matRipple>
                <mat-icon fontIcon="local_offer"></mat-icon>
            </button>
            }
        </div>
        }
        <a class="afon" href="tel:{{partner?.tel}}" (mouseover)="fixsetoultip=true" (mouseleave)="fixsetoultip=false"
            #trigertooltip="cdkOverlayOrigin" cdkOverlayOrigin>
            <span>{{partner?.tel}}</span>
        </a>
        @if(!partner?.hideTermin) {
        <button class="headerbtn" matTooltip="Termin" aria-label="Termin" (click)="gotoCalendar()">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z" />
            </svg>
        </button>
        }
        @if(!partner?.hideChat) {
        <button class="headerbtn" matTooltip="Chat" aria-label="Chat" (click)="openChat()">
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
                <path d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z" />
            </svg>
        </button>
        }
        @if(partner && !partner?.hideLogin) {
        @if(currentCustomer?.email?.length > 0) {

        <button [matMenuTriggerFor]="custmenu" [matTooltip]="currentCustomer?.firstname ? currentCustomer.firstname + ' ' + currentCustomer.lastname :
                            'Mein Konto'" class="headerbtn" matRipple>
            <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24"
                width="24px" fill="currentColor">
                <g>
                    <rect fill="none" height="24" width="24" />
                </g>
                <g>
                    <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6zm0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20z" />
                </g>
            </svg>
        </button>
        <mat-menu #custmenu="matMenu">
            <button mat-menu-item (click)="logout()" aria-label="Logout" matRipple>
                <mat-icon>exit_to_app</mat-icon> Logout
            </button>
        </mat-menu>
        }@else {
        <ng-container *ngTemplateOutlet="anmelden"></ng-container>
        }
        <ng-template #anmelden>
            <button class="headerbtn" matTooltip="Anmelden" aria-label="Anmelden" (click)="gotoPartner()">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px"
                    fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                </svg>
            </button>
        </ng-template>
        }

        @if(partner?.multilangualktiv) {
        <button [matMenuTriggerFor]="langmenu" aria-label="menu" class="cc8" matRipple>
            @switch (i18nService.langUp) {
            @case ('de') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/de.svg" class="langimg" alt="flag de"> <span>Deutsch</span>
            </div>
            }
            @case ('DE') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/de.svg" class="langimg" alt="flag de"> <span>Deutsch</span>
            </div>
            }
            <!-- @case ('TR') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/tr.svg" class="langimg" alt="flag tr"> <span>Türkçe</span>
            </div>
            }
            @case ('tr') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/tr.svg" class="langimg" alt="flag tr"> <span>Türkçe</span>
            </div>
            } -->
            @case ('NL') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/nl.svg" class="langimg" alt="flag nl"> <span>Nederlands</span>
            </div>
            }
            @case ('nl') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/nl.svg" class="langimg" alt="flag nl"> <span>Nederlands</span>
            </div>
            }
            <!-- @case ('FR') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/fr.svg" class="langimg" alt="flag fr"> <span>Français</span>
            </div>
            }
            @case ('fr') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/fr.svg" class="langimg" alt="flag fr"> <span>Français</span>
            </div>
            } -->
            @case ('RU') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/ru.svg" class="langimg" alt="flag ru"> <span>Русский</span>
            </div>
            }
            @case ('ru') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/ru.svg" class="langimg" alt="flag ru"> <span>Русский</span>
            </div>
            }
            @case ('en-GB') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/gb.svg" class="langimg" alt="flag gb"> <span>English</span>
            </div>
            }
            @case ('EN-GB') {
            <div class="langwrp">
                <img src="../../../../../assets/flags/gb.svg" class="langimg" alt="flag gb"> <span>English</span>
            </div>
            }
            }
        </button>
        <mat-menu #langmenu="matMenu">
            <button mat-menu-item (click)="changeLng('de')" aria-label="de" matRipple>
                <div class="langwrp">
                    <img src="../../../../../assets/flags/de.svg" class="langimg" alt="flag de"> <span>Deutsch</span>
                </div>
            </button>
            <!-- <button mat-menu-item (click)="changeLng('tr')" aria-label="tr" matRipple>
                <div class="langwrp">
                    <img src="../../../../../assets/flags/tr.svg" class="langimg" alt="flag tr"> <span>Türkçe</span>
                </div>
            </button> -->
            <!-- <button mat-menu-item (click)="changeLng('fr')" aria-label="fr" matRipple>
                <div class="langwrp">
                    <img src="../../../../../assets/flags/fr.svg" class="langimg" alt="flag fr"> <span>Français</span>
                </div>
            </button> -->
            <button mat-menu-item (click)="changeLng('nl')" aria-label="nl" matRipple>
                <div class="langwrp">
                    <img src="../../../../../assets/flags/nl.svg" class="langimg" alt="flag nl"> <span>Nederlands</span>
                </div>
            </button>
            <button mat-menu-item (click)="changeLng('en-GB')" aria-label="en-GB" matRipple>
                <div class="langwrp">
                    <img src="../../../../../assets/flags/gb.svg" class="langimg" alt="flag gb"> <span>English</span>
                </div>
            </button>
            <button mat-menu-item (click)="changeLng('ru')" aria-label="ru" matRipple>
                <div class="langwrp">
                    <img src="../../../../../assets/flags/ru.svg" class="langimg" alt="flag ru"> <span>Русский</span>
                </div>
            </button>
        </mat-menu>
        }

    </div>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigertooltip"
        [cdkConnectedOverlayOpen]="fixsetoultip">
        <div class="cc17 mat-elevation-z1">
            <div class="cc19">
                <b>{{partner?.tel}}</b><br>
                @if(partner?.opening_period?.length > 0) {
                <span multilang class="mt1 cc20">{{partner?.opening_period}}</span>
                } @else {
                <span multilang>Beratung & Buchung täglich von</span><br>
                <span multilang class="mt1 cc20">{{'08 - 23 Uhr'}}</span>
                }
            </div>
        </div>
    </ng-template>
</ng-template>


<ng-container *ngIf="mobile">
    <div class="sidenav-overlay" [class.hidden]="!menuactive" (click)="closeMenu($event)">
        <div id="mySidenav" class="sidenav noselect customscroll" [class.leftmnu]="desktopTemplate"
            [class.rightmnu]="!desktopTemplate" [class.w100]="mobile">
            <clever-menu2 class="w100" [mobile]="true" [showChat]="!partner?.hideChat"
                [showTermin]="!partner?.hideTermin" [showhReisekompass]="!partner?.hideReisekompass"
                [showhLogin]="!partner?.hideLogin" [showhDigbrater]="!partner?.hideDigbrater"></clever-menu2>
        </div>
    </div>
</ng-container>